/* Proforma automática Prime Outlet (v11) - PDF vectorial con jsPDF + AutoTable
   v11 (2026-10-21): vigencia solo hasta las 23:59 del día, registro de cada proforma
   (PDF en Drive + fila en Google Sheets) y cláusulas de aceptación.
   v11.1 (2026-11-02): envío de S/ 20 sumado al total cuando los productos regulares suman menos de S/ 499. */
(function () {
  if (window.__poProforma) return;
  window.__poProforma = true;

  var CFG = {
    empresa: 'UNION DE CONCRETO RURAL S.A.C.',
    marca: 'PRIME OUTLET',
    ruc: '20604269246',
    direccion: 'Tienda online · Envíos a todo el Perú',
    email: 'contacto@primeoutlet.pe',
    web: 'primeoutlet.pe',
    whatsapp: '51973791565',
    celular: '973 791 565',
    banco: 'Interbank',
    cuenta: '600-3008135212',
    cci: '003-600-003008135212-49',
    descuento: 0.045,
    codigo: 'YAPE2',
    envioGratis: 499,
    envioCosto: 20,
    cuotas: 500,
    /* Registro de proformas (Google Apps Script). Vacío = no registra. */
    registroURL: 'https://script.google.com/macros/s/AKfycbzquDlc2hsqHF54MsD72C1fhCKdBlHWNk70DEWWUIBzl-Y0QNQsRa1fwBK15pFWEff6vg/exec',
    registroToken: 'po-proformas-2026'
  };
  var LIBS = [
    ['https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
     'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js'],
    ['https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js',
     'https://cdn.jsdelivr.net/npm/jspdf-autotable@3.8.2/dist/jspdf.plugin.autotable.min.js']
  ];

  function soles(n) {
    return 'S/ ' + Number(n).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fecha(d) { return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear(); }
  function limpio(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }

  /* ---------- Modal con datos del cliente ---------- */
  function abrirModal() {
    var m = document.getElementById('po-proforma-modal');
    if (!m) {
      m = document.createElement('div');
      m.id = 'po-proforma-modal';
      m.innerHTML =
        '<div class="pom-bg" data-pom-close></div>' +
        '<form class="pom-box" novalidate>' +
        '<button type="button" class="pom-x" data-pom-close aria-label="Cerrar">×</button>' +
        '<h3>Descargar proforma</h3>' +
        '<p class="pom-sub">La proforma sale a tu nombre con los precios actuales de tu carrito y es válida solo hasta hoy a las 23:59.</p>' +
        '<label>Nombre o razón social *<input name="nombre" required maxlength="120" autocomplete="organization"></label>' +
        '<label>DNI o RUC (para boleta o factura)<input name="doc" inputmode="numeric" maxlength="11" placeholder="8 u 11 dígitos"></label>' +
        '<label>Ciudad de entrega *<input name="ciudad" required maxlength="60" autocomplete="address-level2"></label>' +
        '<p class="pom-err" hidden></p>' +
        '<button type="submit" class="button pom-go">Generar PDF</button>' +
        '<p class="pom-legal">Usamos estos datos solo para emitir y registrar tu proforma.</p>' +
        '</form>';
      var st = document.createElement('style');
      st.textContent =
        '#po-proforma-modal{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:16px}' +
        '#po-proforma-modal.open{display:flex}' +
        '#po-proforma-modal .pom-bg{position:absolute;inset:0;background:rgba(0,0,0,.55)}' +
        '#po-proforma-modal .pom-box{position:relative;background:#fff;color:#111;border-radius:12px;max-width:420px;width:100%;padding:24px 22px;box-shadow:0 10px 40px rgba(0,0,0,.3);font-size:15px;letter-spacing:normal}' +
        '#po-proforma-modal h3{margin:0 0 4px;font-size:20px}' +
        '#po-proforma-modal .pom-sub{margin:0 0 14px;font-size:13px;color:#555}' +
        '#po-proforma-modal label{display:block;font-size:13px;font-weight:600;margin-bottom:10px}' +
        '#po-proforma-modal input{display:block;width:100%;margin-top:4px;padding:10px 12px;border:1px solid #bbb;border-radius:8px;font-size:15px;box-sizing:border-box}' +
        '#po-proforma-modal .pom-go{width:100%;margin-top:6px}' +
        '#po-proforma-modal .pom-x{position:absolute;top:8px;right:12px;border:0;background:none;font-size:26px;cursor:pointer;color:#555}' +
        '#po-proforma-modal .pom-err{color:#c00;font-size:13px;margin:4px 0}' +
        '#po-proforma-modal .pom-legal{font-size:11px;color:#777;margin:10px 0 0;text-align:center}';
      document.head.appendChild(st);
      document.body.appendChild(m);
      m.addEventListener('click', function (e) { if (e.target.hasAttribute('data-pom-close')) m.classList.remove('open'); });
      m.querySelector('form').addEventListener('submit', function (e) {
        e.preventDefault();
        var f = e.target, err = f.querySelector('.pom-err');
        var nombre = limpio(f.nombre.value).toUpperCase(), doc = f.doc.value.replace(/\D/g, ''), ciudad = limpio(f.ciudad.value).toUpperCase();
        var msg = '';
        if (!nombre) msg = 'Ingresa tu nombre o razón social.';
        else if (doc && doc.length !== 8 && doc.length !== 11) msg = 'El DNI tiene 8 dígitos y el RUC 11.';
        else if (!ciudad) msg = 'Ingresa la ciudad de entrega.';
        if (msg) { err.textContent = msg; err.hidden = false; return; }
        err.hidden = true;
        var btn = f.querySelector('.pom-go'); btn.disabled = true; btn.textContent = 'Generando…';
        generar({ nombre: nombre, doc: doc, ciudad: ciudad }).catch(function (x) {
          console.error('[proforma]', x);
          err.textContent = 'No se pudo generar el PDF. Inténtalo de nuevo o escríbenos por WhatsApp al ' + CFG.celular + '.'; err.hidden = false;
        }).then(function () { btn.disabled = false; btn.textContent = 'Generar PDF'; });
      });
    }
    m.classList.add('open');
    setTimeout(function () { var i = m.querySelector('input[name=nombre]'); if (i) i.focus(); }, 50);
  }

  /* ---------- Carga de librerías (con CDN de respaldo) ---------- */
  function cargar(urls) {
    return new Promise(function (ok, ko) {
      var i = 0;
      (function intento() {
        if (i >= urls.length) return ko(new Error('no se pudo cargar ' + urls[0]));
        var s = document.createElement('script');
        s.src = urls[i++]; s.async = true;
        s.onload = ok; s.onerror = function () { s.remove(); intento(); };
        document.head.appendChild(s);
      })();
    });
  }
  function cargarLibs() {
    var p = (window.jspdf && window.jspdf.jsPDF) ? Promise.resolve() : cargar(LIBS[0]);
    return p.then(function () {
      var J = window.jspdf.jsPDF;
      if (J && J.API && J.API.autoTable) return;
      return cargar(LIBS[1]);
    });
  }

  /* ---------- PDF ---------- */
  function construirPDF(cart, cli) {
    var J = window.jspdf.jsPDF;
    var doc = new J({ unit: 'mm', format: 'a4' });
    var W = 210, H = 297, M = 14, CW = W - 2 * M;
    var ROJO = [227, 6, 19], NEGRO = [17, 17, 17], GRIS = [90, 90, 90], GRIS2 = [140, 140, 140], FONDO = [245, 245, 245];

    /* Vigencia: solo el mismo día, hasta las 23:59 (precios dinámicos) */
    var hoy = new Date(), vence = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 23, 59, 59);
    var venceTxt = fecha(vence) + ' 23:59';
    var num = 'COT-' + hoy.getFullYear() + pad(hoy.getMonth() + 1) + pad(hoy.getDate()) + '-' + pad(hoy.getHours()) + pad(hoy.getMinutes()) + pad(hoy.getSeconds());
    cart.items.forEach(function (it) { var yd = (it.line_level_discount_allocations || []).filter(function (a) { var da = a.discount_application || {}; return String(da.title || '').toUpperCase() === CFG.codigo; }).reduce(function (s, a) { return s + a.amount; }, 0); if (yd) { it.final_line_price += yd; it.final_price = Math.round(it.final_line_price / it.quantity); } }); var total = cart.items.reduce(function (s, it) { return s + it.final_line_price; }, 0) / 100;
    var esLiq = function (it) { return /^liq-/.test(it.handle || ''); }; var liqTotal = cart.items.filter(esLiq).reduce(function (a, it) { return a + it.final_line_price; }, 0) / 100; var normTotal = Math.round((total - liqTotal) * 100) / 100; var hayLiq = liqTotal > 0, soloLiq = hayLiq && normTotal <= 0.005; var dscto = Math.round(normTotal * CFG.descuento * 100) / 100;
    var envioMonto = (!soloLiq && normTotal > 0 && normTotal < CFG.envioGratis) ? CFG.envioCosto : 0; total = Math.round((total + envioMonto) * 100) / 100;
    var totalT = Math.round((total - dscto) * 100) / 100;
    var vv = total / 1.18, igv = total - vv, vvT = totalT / 1.18, igvT = totalT - vvT;

    function txt(t, x, y, o) {
      o = o || {};
      doc.setFont('helvetica', o.b ? 'bold' : 'normal');
      doc.setFontSize(o.s || 9);
      doc.setTextColor.apply(doc, o.c || NEGRO);
      doc.text(t, x, y, { align: o.a || 'left', maxWidth: o.w });
    }

    /* Encabezado: logotipo como en la tienda, PRIME en negrita negra + OUTLET. delgado en rojo */
    txt('PRIME', M, 22, { b: 1, s: 22, c: [0, 0, 0] });
    doc.setFont('helvetica', 'bold'); doc.setFontSize(22);
    var lw = doc.getTextWidth('PRIME') + 2.2;
    txt('OUTLET.', M + lw, 22, { s: 22, c: ROJO });
    txt(CFG.empresa, M, 28.5, { b: 1, s: 9.5 });
    txt('RUC ' + CFG.ruc + '  ·  ' + CFG.direccion, M, 33.5, { s: 8, c: GRIS });
    txt(CFG.email + '  ·  ' + CFG.web + '  ·  WhatsApp / Yape / Plin ' + CFG.celular, M, 38, { s: 8, c: GRIS });
    var bx = W - M - 62, by = 13;
    doc.setDrawColor.apply(doc, ROJO); doc.setLineWidth(0.6);
    doc.roundedRect(bx, by, 62, 28, 2.5, 2.5);
    txt('PROFORMA', bx + 58, by + 8, { b: 1, s: 14, c: ROJO, a: 'right' });
    txt('N.° ' + num, bx + 58, by + 14.5, { b: 1, s: 9, a: 'right' });
    txt('Fecha: ' + fecha(hoy), bx + 58, by + 19.5, { s: 8.5, a: 'right' });
    txt('Válida hasta: ' + fecha(vence), bx + 58, by + 24.5, { s: 8.5, a: 'right' });

    /* Cliente */
    var cy = 46;
    doc.setFillColor.apply(doc, FONDO); doc.roundedRect(M, cy, CW, 17, 2, 2, 'F');
    txt('CLIENTE', M + 4, cy + 5, { s: 6.5, c: GRIS2 });
    txt(cli.nombre, M + 4, cy + 10, { b: 1, s: 9.5, w: 92 });
    if (cli.doc) txt((cli.doc.length === 11 ? 'RUC: ' : 'DNI: ') + cli.doc, M + 4, cy + 14.5, { s: 8.5 });
    txt('DESTINO DE ENVÍO', M + 104, cy + 5, { s: 6.5, c: GRIS2 });
    txt(cli.ciudad + ', PERÚ', M + 104, cy + 10, { b: 1, s: 9.5, w: 44 });
    txt('MONEDA', M + 152, cy + 5, { s: 6.5, c: GRIS2 });
    txt('Soles (PEN)', M + 152, cy + 10, { b: 1, s: 9.5 });

    /* Detalle */
    var filas = cart.items.map(function (it, i) {
      var d = limpio(it.product_title) + (it.variant_title ? ' - ' + limpio(it.variant_title) : '') + (it.sku ? '\nCódigo: ' + it.sku : '') + (esLiq(it) ? '\nLIQUIDACIÓN · solo pago directo' : '');
      return [String(i + 1), d, String(it.quantity), soles(it.final_price / 100), soles(it.final_line_price / 100)];
    });
    if (envioMonto) filas.push([String(filas.length + 1), 'Envío a ' + cli.ciudad + '\nPedido menor a S/ ' + CFG.envioGratis + ' (envío gratis desde ese monto)', '1', soles(envioMonto), soles(envioMonto)]);
    doc.autoTable({
      startY: cy + 22,
      margin: { left: M, right: M, bottom: 18 },
      head: [['#', 'Descripción', 'Cant.', 'P. unitario', 'Importe']],
      body: filas,
      theme: 'plain',
      styles: { font: 'helvetica', fontSize: 8.5, cellPadding: { top: 2.2, bottom: 2.2, left: 2, right: 2 }, textColor: NEGRO, valign: 'top', lineColor: [225, 225, 225] },
      headStyles: { fillColor: NEGRO, textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 7.5 },
      columnStyles: { 0: { cellWidth: 8 }, 2: { cellWidth: 13, halign: 'center' }, 3: { cellWidth: 27, halign: 'right' }, 4: { cellWidth: 28, halign: 'right' } },
      didParseCell: function (d) {
        if (d.section === 'body') d.cell.styles.lineWidth = { bottom: 0.2 };
        if (d.section === 'head' && d.column.index >= 3) d.cell.styles.halign = 'right';
        if (d.section === 'head' && d.column.index === 2) d.cell.styles.halign = 'center';
      }
    });
    var y = doc.lastAutoTable.finalY + 6;
    if (y + 112 > H - 18) { doc.addPage(); y = 20; }

    /* Formas de pago */
    if (hayLiq) { var bh2 = soloLiq ? 30 : 42; doc.setFillColor(255, 244, 244); doc.setDrawColor.apply(doc, ROJO); doc.setLineWidth(0.6); doc.roundedRect(M, y, CW, bh2, 2, 2, 'FD'); txt('Pago directo: Yape, Plin o transferencia (único medio de pago)', M + 4, y + 6, { b: 1, s: 9.5, c: ROJO }); var ly = y + 12; if (!soloLiq) { txt('Productos regulares: ' + soles(normTotal) + '  -4.5% (código ' + CFG.codigo + '): -' + soles(dscto) + '  =  ' + soles(normTotal - dscto) + (envioMonto ? '  ·  Envío: ' + soles(envioMonto) : ''), M + 4, ly, { s: 8.5 }); ly += 4.5; } txt('Productos en liquidación (precio final, sin código de descuento): ' + soles(liqTotal), M + 4, ly, { s: 8.5 }); ly += 4.5; txt('Valor de venta: ' + soles(vvT) + '   ·   IGV (18%): ' + soles(igvT), M + 4, ly, { s: 8.5 }); ly += 6.5; txt('Total: ' + soles(totalT), M + 4, ly, { b: 1, s: 12.5, c: ROJO }); if (!soloLiq) txt('Incluye productos en liquidación: todo el pedido se paga directo. Si prefieres tarjeta o cuotas para los productos regulares, cómpralos en un pedido aparte.', M + 4, ly + 5, { s: 7, c: GRIS, w: CW - 8 }); y += bh2 + 5; } else { var bw = (CW - 6) / 2, bh = 33;
    doc.setDrawColor(210, 210, 210); doc.setLineWidth(0.3); doc.roundedRect(M, y, bw, bh, 2, 2);
    txt('Pago web', M + 4, y + 6, { b: 1, s: 9.5 });
    txt('Tarjeta, Yape o Plin vía Mercado Pago en ' + CFG.web, M + 4, y + 10.5, { s: 7.5, c: GRIS });
    txt('Valor de venta: ' + soles(vv), M + 4, y + 16, { s: 8.5 });
    txt('IGV (18%): ' + soles(igv), M + 4, y + 20.5, { s: 8.5 });
    txt('Total: ' + soles(total), M + 4, y + 27, { b: 1, s: 12.5 });
    if (total - envioMonto >= CFG.cuotas) txt('Hasta 3 cuotas sin interés con tarjeta de crédito', M + 4, y + 31, { s: 7, c: GRIS });
    var x2 = M + bw + 6;
    doc.setFillColor(255, 244, 244); doc.setDrawColor.apply(doc, ROJO); doc.setLineWidth(0.6);
    doc.roundedRect(x2, y, bw, bh, 2, 2, 'FD');
    txt('Transferencia / Yape / Plin directo · 4.5% dscto.', x2 + 4, y + 6, { b: 1, s: 9, c: ROJO });
    txt('Valor de venta: ' + soles(vvT), x2 + 4, y + 16, { s: 8.5 });
    txt('IGV (18%): ' + soles(igvT), x2 + 4, y + 20.5, { s: 8.5 });
    txt('Total: ' + soles(totalT), x2 + 4, y + 27, { b: 1, s: 12.5, c: ROJO });
    txt('Ahorras ' + soles(dscto) + ' frente al pago web', x2 + 4, y + 31, { s: 7, c: GRIS });
    y += bh + 5; }

    /* Datos de pago */
    var dh = 37;
    doc.setDrawColor(210, 210, 210); doc.setLineWidth(0.3); doc.roundedRect(M, y, CW, dh, 2, 2);
    txt('Datos para el pago directo', M + 4, y + 6, { b: 1, s: 9.5 });
    var datos = [
      ['Banco', CFG.banco],
      ['Titular', CFG.empresa + ' (RUC ' + CFG.ruc + ')'],
      ['Cuenta corriente soles', CFG.cuenta],
      ['CCI', CFG.cci],
      ['Yape / Plin', CFG.celular],
      ['Referencia', num]
    ];
    datos.forEach(function (r, i) {
      txt(r[0], M + 4, y + 11.5 + i * 4.2, { s: 8, c: GRIS });
      txt(r[1], M + 46, y + 11.5 + i * 4.2, { s: 8, b: r[0] === 'Referencia' });
    });
    y += dh + 6;

    /* Condiciones */
    txt('Términos y condiciones', M, y, { b: 1, s: 9.5 }); y += 4.5;
    var envio = soloLiq ? 'Envío pago en destino vía agencia Shalom: el flete se paga al recoger, según tamaño y peso.' : (hayLiq ? 'Productos en liquidación: envío pago en destino vía agencia Shalom (el flete se paga al recoger). Productos regulares: ' : '') + (normTotal >= CFG.envioGratis
      ? 'Envío GRATIS (pedidos desde S/ ' + CFG.envioGratis + ').'
      : 'Envío a ' + cli.ciudad + ': ' + soles(CFG.envioCosto) + ', ya incluido en esta proforma (gratis en pedidos desde S/ ' + CFG.envioGratis + ').');
    var conds = [
      'Vigencia: proforma válida solo hasta las 23:59 del ' + fecha(vence) + '. Nuestros precios son dinámicos y pueden cambiar desde el día siguiente; vencido el plazo, genera una nueva proforma en ' + CFG.web + '.',
      'Aceptación: esta proforma es una cotización referencial y no reserva stock ni obliga a la venta. El pedido queda aceptado solo cuando el cliente lo confirma por WhatsApp o correo indicando el N.° ' + num + ' y realiza el pago dentro de la vigencia. Stock sujeto a disponibilidad al momento del pago.',
      (soloLiq ? 'Precios en soles, incluyen IGV. Productos en liquidación: unidad única, con el estado y la garantía indicados en cada producto.' : hayLiq ? 'Precios en soles, incluyen IGV. Productos regulares nuevos con garantía de fábrica. Productos en liquidación: unidad única, con el estado y la garantía indicados en cada producto.' : 'Precios en soles, incluyen IGV. Productos nuevos, en caja sellada, con garantía de fábrica según las condiciones de cada marca.'),
      envio + ' Los plazos de entrega se cuentan desde la confirmación del pago.',
      (soloLiq ? 'Los productos en liquidación se pagan solo por transferencia a la cuenta indicada, Yape o Plin al ' + CFG.celular + '. No aplica el código ' + CFG.codigo + ' (ya tienen su precio final).' : (hayLiq ? 'Los productos en liquidación se pagan solo de forma directa y ya tienen su precio final; el 4.5% aplica solo a los productos regulares. ' : '') + 'El precio con 4.5% de descuento aplica solo a pagos directos (transferencia a la cuenta indicada, Yape o Plin al ' + CFG.celular + '). En la web: elige el pago "Yape / Plin / Transferencia" y usa el código ' + CFG.codigo + '.'),
      'Envía la constancia por WhatsApp al ' + CFG.celular + ' o a ' + CFG.email + ' indicando N.° ' + num + '.',
      'Emitimos boleta o factura electrónica' + (cli.doc && cli.doc.length === 11 ? ' (factura a RUC ' + cli.doc + ').' : '.') + ' Los datos del cliente deben ser correctos al confirmar el pedido.'
    ];
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor.apply(doc, [50, 50, 50]);
    conds.forEach(function (c) {
      var ls = doc.splitTextToSize(c, CW - 5);
      if (y + ls.length * 3.6 > H - 18) { doc.addPage(); y = 20; }
      doc.text('•', M + 1, y);
      doc.text(ls, M + 5, y);
      y += ls.length * 3.6 + 0.8;
    });

    /* Pie en todas las páginas */
    var n = doc.getNumberOfPages();
    for (var p = 1; p <= n; p++) {
      doc.setPage(p);
      doc.setDrawColor.apply(doc, ROJO); doc.setLineWidth(0.5); doc.line(M, H - 13, W - M, H - 13);
      txt('Gracias por tu preferencia. ' + CFG.marca + ' — ' + CFG.empresa + ' · RUC ' + CFG.ruc + ' · ' + CFG.web + ' · WhatsApp ' + CFG.celular, W / 2, H - 8.5, { s: 7, c: GRIS, a: 'center' });
      if (n > 1) txt('Página ' + p + ' de ' + n, W - M, H - 4.5, { s: 7, c: GRIS2, a: 'right' });
    }
    return { doc: doc, num: num, total: total, totalT: totalT, venceTxt: venceTxt };
  }

  function generar(cli) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) throw new Error('carrito vacío');
        return cargarLibs().then(function () {
          var p = construirPDF(cart, cli);
          p.doc.save('Proforma_' + p.num + '_Prime_Outlet.pdf');
          guardarEnCarrito(p, cli);
          registrar(p, cli, cart);
          mostrarListo(p, cli);
        });
      });
  }

  /* Deja la proforma registrada en el carrito: si el cliente compra, aparece en el pedido (Detalles adicionales) */
  function guardarEnCarrito(p, cli) {
    try {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: {
          'Proforma': p.num,
          'Proforma - cliente': cli.nombre,
          'Proforma - DNI/RUC': cli.doc || '-',
          'Proforma - ciudad': cli.ciudad,
          'Proforma - total transferencia': soles(p.totalT)
        } })
      }).catch(function (e) { console.warn('[proforma] no se guardó en el carrito', e); });
    } catch (e) { console.warn('[proforma]', e); }
  }

  /* Registro interno: envía el PDF y los datos al registro de proformas (Drive + Google Sheets) */
  function registrar(p, cli, cart) {
    if (!CFG.registroURL || CFG.registroURL.indexOf('https://') !== 0) return;
    try {
      var unidades = 0;
      var items = cart.items.map(function (it) {
        unidades += it.quantity;
        return it.quantity + ' x ' + limpio(it.product_title) + (it.variant_title ? ' - ' + limpio(it.variant_title) : '') +
          (it.sku ? ' [' + it.sku + ']' : '') + ' = ' + soles(it.final_line_price / 100);
      }).join('\n');
      var pdf = p.doc.output('datauristring');
      pdf = pdf.slice(pdf.indexOf(',') + 1);
      fetch(CFG.registroURL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          token: CFG.registroToken,
          num: p.num,
          cliente: cli.nombre,
          doc: cli.doc || '-',
          ciudad: cli.ciudad,
          totalWeb: p.total,
          totalDirecto: p.totalT,
          items: items,
          unidades: unidades,
          vence: p.venceTxt,
          pagina: location.href,
          pdf: pdf
        })
      }).catch(function (e) { console.warn('[proforma] no se registró', e); });
    } catch (e) { console.warn('[proforma] registro', e); }
  }

  function mostrarListo(p, cli) {
    var box = document.querySelector('#po-proforma-modal .pom-box');
    if (!box) return;
    var t = 'Hola Prime Outlet, descargué la proforma ' + p.num + ' a nombre de ' + cli.nombre +
      (cli.doc ? ' (' + cli.doc + ')' : '') + ' para envío a ' + cli.ciudad + '. Total pago directo: ' + soles(p.totalT) + '. Quisiera confirmar el pedido.';
    box.innerHTML = '<button type="button" class="pom-x" data-pom-close aria-label="Cerrar">×</button>' +
      '<h3>✅ Proforma descargada</h3><p class="pom-sub">N.° ' + p.num + ' · válida hasta hoy ' + p.venceTxt + '. Revisa tu carpeta de descargas.</p>' +
      '<p style="font-size:14px;margin:0 0 12px">Los precios pueden cambiar mañana. Confírmanos tu pedido hoy por WhatsApp y te atendemos al momento.</p>' +
      '<a class="button" style="width:100%;background:#25D366;color:#fff" target="_blank" rel="noopener" href="https://wa.me/' + CFG.whatsapp + '?text=' + encodeURIComponent(t) + '">Confirmar por WhatsApp</a>';
    document.getElementById('po-proforma-modal').dataset.used = '1';
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-po-proforma]');
    if (!b) return;
    e.preventDefault();
    var d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('active') && typeof d.close === 'function') d.close();
    var m = document.getElementById('po-proforma-modal');
    if (m && m.dataset.used) { m.remove(); }
    abrirModal();
  });
})();
